import { atomWithDebounce } from "@sunrise/utils";

const SEARCH_DEBOUNCE_DELAY = 500;

export const debouncedQueryAtoms = atomWithDebounce<string>(
  "",
  SEARCH_DEBOUNCE_DELAY,
);
